/**
 * Ficha de produto no telemóvel — o comportamento da proposta aprovada a
 * 15-09-2026 (galeria a deslizar, «Mostrar mais» na descrição e na ficha
 * técnica). O desenho vive no cybertek-web.bundle.css; aqui só o que o CSS
 * não consegue fazer sozinho.
 *
 * No computador nada disto se vê: os botões ficam escondidos pelo CSS acima
 * de 576px, e a galeria do telemóvel também.
 */
(function () {
	"use strict";

	const MOVEL = window.matchMedia("(max-width: 576px)");
	const LINHAS_VISIVEIS = 6;

	function botao(texto) {
		const b = document.createElement("button");
		b.type = "button";
		b.className = "ct-mostrar-mais";
		b.textContent = texto;
		b.setAttribute("aria-expanded", "false");
		return b;
	}

	// Os pontos acompanham a fotografia que está à vista. Conta-se pela
	// posição da faixa, não por eventos de toque: assim também funciona com
	// o teclado e com o deslizar por inércia.
	function galeria() {
		document.querySelectorAll(".ct-galeria-movel").forEach((g) => {
			const faixa = g.querySelector(".ct-galeria-faixa");
			const pontos = Array.from(g.querySelectorAll(".ct-galeria-pontos span"));
			if (!faixa || pontos.length < 2) return;
			let pedido = 0;
			faixa.addEventListener(
				"scroll",
				() => {
					cancelAnimationFrame(pedido);
					pedido = requestAnimationFrame(() => {
						const i = Math.round(faixa.scrollLeft / Math.max(faixa.clientWidth, 1));
						pontos.forEach((p, j) => p.classList.toggle("activo", j === i));
					});
				},
				{ passive: true }
			);
		});
	}

	// O botão só aparece se a descrição passar mesmo das 4 linhas — uma
	// descrição curta com «Mostrar mais» por baixo prometia texto que não há.
	function descricao() {
		const seccao = document.querySelector(".ct-seccao-descricao");
		const texto = seccao && seccao.querySelector(".product-description");
		if (!texto || seccao.querySelector(".ct-mostrar-mais")) return;

		const b = botao(__("Mostrar mais"));
		seccao.appendChild(b);

		const avaliar = () => {
			if (seccao.classList.contains("ct-aberta")) return;
			b.hidden = !(MOVEL.matches && texto.scrollHeight > texto.clientHeight + 2);
		};

		b.addEventListener("click", () => {
			const aberta = seccao.classList.toggle("ct-aberta");
			b.textContent = aberta ? __("Mostrar menos") : __("Mostrar mais");
			b.setAttribute("aria-expanded", String(aberta));
			if (!aberta) seccao.scrollIntoView({ block: "nearest" });
		});

		avaliar();
		MOVEL.addEventListener("change", avaliar);
		window.addEventListener("load", avaliar);
	}

	// Ficha técnica: as primeiras linhas à vista, o resto atrás de um botão
	// que diz quantas faltam.
	function especificacoes() {
		const ficha = document.querySelector(".product-page .item-website-specification");
		if (!ficha || ficha.querySelector(".ct-mostrar-mais")) return;
		const escondidas = ficha.querySelectorAll("tr").length - LINHAS_VISIVEIS;
		if (escondidas <= 0) return;

		const fechado = `${__("Mostrar mais")} (${escondidas})`;
		const b = botao(fechado);
		ficha.appendChild(b);
		b.addEventListener("click", () => {
			const aberta = ficha.classList.toggle("ct-aberta");
			b.textContent = aberta ? __("Mostrar menos") : fechado;
			b.setAttribute("aria-expanded", String(aberta));
		});
	}

	function iniciar() {
		if (!document.querySelector(".product-page")) return;
		galeria();
		descricao();
		especificacoes();
	}

	if (typeof frappe !== "undefined" && frappe.ready) frappe.ready(iniciar);
	else document.addEventListener("DOMContentLoaded", iniciar);
})();
